(function ($, Drupal, window, document) {
  'use strict';

  Drupal.behaviors.scrollspyCustomNav = {
    attach: function scrollspyCustomNav(context, settings) {
      if (typeof context['location'] !== 'undefined') {// Only fire on document load.
        window.addEventListener('load', function() {
          var anchorsToCreate = [];

          // Get all direct children from first .node__content element OR layout builder sections (still using this just for backwards-compatibility with work done previously on MA)
          var directChildren = $(`.block--main-page-content .node__content:first .pre-content-layout-region,
                                  .block--main-page-content .node__content:first .main__wrapper > .container > .layout,
                                  .block--main-page-content .node__content:first .post-content-layout-region,
                                  .region-postfix,
                                  .block--main-page-content .node__content:first`).children();

          // Get all elements that have 'scroll-' at the start of its id
          var scrollElements = $(`[id^=scroll-]`);

          // Merge two array together while replacing duplicates
          var elementsToTraverse = $.extend(directChildren, scrollElements);

          // Iterate though elements needing to be traversed...
          $.each(elementsToTraverse, (index, element) => {
            if ($('#block-scrollspycontainerblock-degrees-program').length) {
              if (!$(element).parent().hasClass('block--degrees-programs-scrollspy')) {
                return;
              }
            }

            var elementID = $(element).attr('id');

            // If the current element has an ID attribute...
            if (elementID !== undefined) {
              // Find h2s, grab the first only (h2s may be nested within an element), and retrieve it's text
              var h2Text = $(element).find('h2.field__label, .fieldset__legend h2, h2.block__title').first().text();

              // If this element has an h2...
              if (h2Text.length > 0) {
                if (elementID == 'scroll-visit-department') {
                  elementID = h2Text;
                  h2Text = 'Visit Department';
                }

                if ($(element).parent().hasClass('block--degrees-programs-scrollspy')) {
                  elementID = $(element).find('[id^=scroll-dp-]').first().text();
                }

                anchorsToCreate.push({ element, h2Text, elementID });
              }
            }
          });

          var isProgram = ($('body.page-node-type-program').length > 0) ? true : false;

          // Building the markup
          var builtMarkupString = `<div id="navbar-scrollspy" class="navbar-scroll">`;
          builtMarkupString += `<div class="navbar-scroll-container container">`;
          builtMarkupString += `<div class="row">`;

          if (isProgram) {
            builtMarkupString += `<div class="col col-md-6 col-lg-7 col-xl-8 headings">`;
          }
          else {
            builtMarkupString += `<div class="col-12 headings">`;
          }

          var visitDepartmentMarkupString;

          $.each(anchorsToCreate, (index, element) => {
            if (element.h2Text == 'Visit Department') {
              visitDepartmentMarkupString = `<a class="programs__department-button" href=${element.elementID}>${element.h2Text.trim()}</a>`;
            }
            else {
              if ($(element.element).parent().hasClass('block--degrees-programs-scrollspy')) {
                builtMarkupString += `<a href=${element.elementID}>${element.h2Text.trim()}</a>`;
              }
              else {
                // Add each anchor tag with its corresponding data to the built markup
                builtMarkupString += `<a href=#${element.elementID}>${element.h2Text.trim()}</a>`;
              }
            }
          });

          var applyNowMarkupString = '<a class="programs__apply-now" href="/apply">Apply Now</a>';
          var applyNowMobileMarkupString;

          if (isProgram) {
            if (visitDepartmentMarkupString) {
              applyNowMobileMarkupString = `<div class="programs__apply-now--mobile-container">${visitDepartmentMarkupString}<a class="programs__apply-now programs__apply-now--mobile" href="/apply">Apply Now</a></div>`;
              builtMarkupString += `</div><div class="d-none d-md-block col-sm-7 col-md-6 col-lg-5 col-xl-4 action-buttons">` +
                                visitDepartmentMarkupString +
                                applyNowMarkupString +
                                '</div></div></div></div>' +
                                applyNowMobileMarkupString;
            }
            else {
              applyNowMobileMarkupString = '<div class="programs__apply-now--mobile-container"><a class="programs__apply-now programs__apply-now--mobile" href="/apply">Apply Now</a></div>';
              builtMarkupString += `</div><div class="d-none d-md-block col-sm-7 col-md-6 col-lg-5 col-xl-4 action-buttons">` +
                                applyNowMarkupString +
                                '</div></div></div></div>' +
                                applyNowMobileMarkupString;
            }
          }
          else {
            builtMarkupString += '</div></div></div>';
          }

          // Add the markup to the .region-content as the first direct child
          $('#block-scrollspycontainerblock > .block__content, #block-scrollspycontainerblock-degrees-program > .block__content').first().prepend(builtMarkupString);

          // Initialize scrollspy on the markup
          var navbar = $('#navbar-scrollspy');

          // Below is the functionality for the bar to scroll automatically on when links are out of the viewport but the component is within sight.
          var offset = 25;
          var anchorData = [];
          window.anchorData = anchorData;
          var anchors = $('.navbar-scroll-container  a');

          // Checking if any anchors were found.
          if (anchors.length > 0) {
            $('.navbar-scroll-container').addClass('scroll-not-empty');
          }

          // Store each created anchor with its x position in the bar and its text.
          $.each(anchors, (index, element) => {
            window.anchorData.push({
              element,
              'x': $(element).position().left,
              'text': $(element).text()
            });
          });

          // Credits go to Colin Smith, taken from sidebar.js file.
          // ------------------------------------------------------------
          // On window load, get header and toolbar height (if logged in), and attach Zebra_Pin library to .region-scrollspy-container to be sticky.
          var zp_nav_scrollspy = new $.Zebra_Pin($('.region-scrollspy-container'), {
            z_index: 460,
            top_spacing: calculateOffset() ,
          });
          if (document.querySelector('body').classList.contains('user-logged-in')) {
            var scrollspy = new VanillaScrollspy(navbar[0], undefined, undefined, 0 - calculateLoggedInOffset());
            scrollspy.recalculateFn = function() {return 0 - calculateLoggedInOffset()};
          } else {
            var scrollspy = new VanillaScrollspy(navbar[0], undefined, undefined, calculateLoggedOutOffset());
            scrollspy.recalculateFn = function() {return calculateLoggedOutOffset() };
          }
          scrollspy.init();
          window.scrollspy = scrollspy;
        });

        // Helper function used to detect if element is within the viewport.
        // Credits go to Dan on StackOverflow:
        // https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
        // ------------------------------------------------------------
        function isElementInViewport (el) {
          //special bonus for those using jQuery
          if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
          }

          var rect = el.getBoundingClientRect();

          return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
          );
        }


        // On window scroll...
        function scrollSpyMobileScroll() {
          // Grab the active anchors text.
          var activeAnchorText = $('.navbar-scroll-container a.active').first().text();

          // If active element exists...
          if (activeAnchorText.length > 0) {
            // Loop through created anchors and find the element in the array that has the active anchors text and store that element.
            var xToScrollTo = window.anchorData.find(element => element.text == activeAnchorText);

            // If an element was found from the loop above AND the element is not in the viewport...
            if (xToScrollTo != undefined && !isElementInViewport($(xToScrollTo.element)[0])) {
              // Scroll the bar to the position of the newly active anchor.
              $('.navbar-scroll-container').stop(true, false).animate({scrollLeft: xToScrollTo.x - calculateLoggedOutOffset()}, 100);
            }
          }
        };

        // Debounce window scroll event.
        var windowScroll;
        window.onscroll = function() {
          clearTimeout(windowScroll);
          windowScroll = setTimeout(scrollSpyMobileScroll(), 100);
        };
      }
    }
  };
  function calculateOffset($=jQuery) {
    var hasFixedAdminToolbar = $('body').hasClass('toolbar-fixed');
    var adminToolbarHeight = (hasFixedAdminToolbar) ? parseInt($('body').css('padding-top'), 10) : 0;
    var preHeaderOffsetHeight = $('.region-navigation').outerHeight();
    var preMobileHeaderOffsetHeight = $('.region-mobile-navigation').outerHeight();
    var topOffset = ($('.region-navigation').is(':visible')) ? adminToolbarHeight + preHeaderOffsetHeight : adminToolbarHeight + preMobileHeaderOffsetHeight;
    return topOffset;
  }
  function calculateLoggedInOffset() {
    //scrollspy bar
    return getHeightIfIdExists('block-views-block-contextual-banner') +
    getHeightIfIdExists('toolbar-bar') +
    getHeightIfIdExists('toolbar-item-administration-tray') +
    getHeightIfClassExists('.region-header .messages') +
    getHeightIfIdExists('block-views-block-alerts-information-alert-block') -
    getHeightIfIdExists('block-mount-allison-local-tasks');
  }

  function calculateLoggedOutOffset() {
    return getHeightIfClassExists('.region-navigation') +
    getHeightIfIdExists('navbar-scrollspy');
  }

  function getHeightIfIdExists(str) {
    let ele = document.getElementById(str);
    if (ele) {
      return ele.clientHeight;
    } else {
      return 0;
    }
  }

  function getHeightIfClassExists(str) {
    let ele = document.querySelector(str);
    if (ele) {
      return ele.clientHeight;
    } else {
      return 0;
    }
  }

})(jQuery, Drupal, window, document);
